import { info } from "console"
import { InventoryModelWithProductStat } from "."
import { APP_CONFIG } from "../config/appconfig"
import { InventoryModel } from "./inventory"

export interface IDongGoi {
    id: string
    don_vi: {
        name: string,
        id: string
    }
    duoc_ban_le: boolean
    loai_dong_goi: {
        name: string,
        id: string
    }
    so_luong: number
    inventory?: InventoryModelWithProductStat,
    level: number
}

export interface IProductLog {
    mCreated: string,
    mLastUpdateBy: string,
    mLastUpdateById: number,
    mLastUpdateByName: string,
    mPrice: number,
    mStatus: string,
    mInStock: boolean,
    mSoldAmount: number,
    mOriginalPrice: number,
    mPharmacyProductMap: {
        mPackageId: string,
    },
    mDongGoi?: IDongGoi,
    [key: string]: any
}

export class ProductModel {
    _id: string
    ah_co_thai_cho_con_bu: string
    mPkgName: string
    mPrice: number
    mStockAmount: number
    mStatus: string
    ah_lai_xe: string
    bao_quan: string
    chong_chi_dinh: string
    duoc_ly: string
    han_dung: string
    qua_lieu: string
    tac_dung_khong_mong_muon: string
    than_trong: string
    thanh_phan: string
    tuong_tac_thuoc: string
    phan_loai: string
    cong_dung_chi_dinh: string
    sku_id: string
    imageUrls: Array<string>
    khoi_luong_the_tich: string
    lieu_luong_cach_dung: string
    loai: string
    mo_ta: string
    name: string
    nha_cung_cap: Array<any>
    nha_san_xuat: string
    nhom_san_pham: any
    phan_loai_san_pham: string
    phan_loais: Array<any>
    dong_goi: Array<IDongGoi>
    quy_cach_dong_goi: Array<any>
    category: string
    pageUrl: string

    [key: string]: any

    constructor(product?: any) {
        this._id = product?._id || ''
        this.ah_co_thai_cho_con_bu = product?.ah_co_thai_cho_con_bu || ''
        this.mPkgName = product?.mPkgName || ''
        this.mStatus = product?.mStatus || ''
        this.mPrice = product?.mPrice || 0
        this.mStockAmount = product?.mStockAmount || 0
        this.ah_lai_xe = product?.ah_lai_xe || ''
        this.bao_quan = product?.bao_quan || ''
        this.chong_chi_dinh = product?.chong_chi_dinh || ''
        this.duoc_ly = product?.duoc_ly || ''
        this.han_dung = product?.han_dung || ''
        this.qua_lieu = product?.qua_lieu || ''
        this.tac_dung_khong_mong_muon = product?.tac_dung_khong_mong_muon || ''
        this.than_trong = product?.than_trong || ''
        this.thanh_phan = product?.thanh_phan || ''
        this.tuong_tac_thuoc = product?.tuong_tac_thuoc || ''
        this.phan_loai = product?.phan_loai || ''
        this.nhom_san_pham = product?.nhom_san_pham || ''
        this.cong_dung_chi_dinh = product?.cong_dung_chi_dinh || ''
        this.lieu_luong_cach_dung = product?.lieu_luong_cach_dung || ''
        this.sku_id = product?.sku_id || ''
        this.imageUrls = product?.imageUrls || []
        this.khoi_luong_the_tich = product?.khoi_luong_the_tich || ''
        this.loai = product?.loai || ''
        this.mo_ta = product?.mo_ta || ''
        this.name = product?.name || ''
        this.nha_cung_cap = product?.nha_cung_cap || ''
        this.nha_san_xuat = product?.nha_san_xuat || ''
        this.phan_loai_san_pham = product?.phan_loai_san_pham || ''
        this.phan_loais = product?.phan_loais || ''
        this.quy_cach_dong_goi = product?.quy_cach_dong_goi || ''
        this.dong_goi = product?.dong_goi || []
        this.category = product?.category || ''
        this.pageUrl = product?.pageUrl || ''
    }
}

export class ProductViewModel {
    product: ProductModel

    constructor(product: ProductModel) {
        if (!product) {
            this.product = new ProductModel({})
            return
        }

        this.product = new ProductModel(product)

        this.getViewDetailInfo = this.getViewDetailInfo.bind(this)

    }

    getViewDetailInfo() {
        const categoriesFormat = APP_CONFIG.general.ecommerce.categories
        const format = APP_CONFIG.general.ecommerce.productFields
        const info = [] as { title: string, field: string, value: string }[]

        var foundCategory = categoriesFormat.find(item => Object.keys(item)[0] == this.product.category);
        var category = foundCategory ? Object.values(foundCategory)[0] : '';
        info.push({ title: 'Danh mục sản phẩm', field: '', value: category || '' })

        format.forEach((item: any) => {
            const field = Object.keys(item)[0]
            const value = this.product[field]
            const title = item[field]

            if (typeof value === 'string' && value != '') {
                let content = value.replace(/\r\n/g, "<br/>")
                content = content.replace(/\n/g, "<br/>")
                content = content.replace(/[]/g, "")

                info.push({ title, field, value: content })
            }

            if (field === 'phan_loais') {
                if (Array.isArray(value) && value.length != 0) {
                    let content = ''
                    value.forEach(item => {
                        content = content + `${item?.name}<br/>`
                    })
                    info.push({ title, field, value: content })
                }
            }
        })

        return info
    }
}